import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HotkeyModule } from 'angular2-hotkeys';
import {
  HeaderComponent,
  HeaderService,
  AlertNotificationService,
} from './../header';
import { CoreModule } from '../core/core.module';
//import { TrialGuardService } from '../core';
import { AuthGuard } from './../core/guards/auth.guard';
import { FilterModule } from '../filter/filter.module';
import { MatIconModule } from '@angular/material/icon';
import { LocaleFormatsService } from '@/app/header/locale-formats.service';
import { SearchService } from '@/app/header/search.service';
import { AlertMenuComponent } from './alert-menu.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    CoreModule,
    RouterModule,
    InfiniteScrollModule,
    HotkeyModule,
    FilterModule,
    MatIconModule,
    AlertMenuComponent,
  ],
  declarations: [HeaderComponent],
  providers: [
    HeaderService,
    SearchService,
    AlertNotificationService,
    AuthGuard,
    LocaleFormatsService,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
